"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLinkWidget = exports.TextLinkKind = void 0;
var tslib_1 = require("tslib");
var tableau_ui_1 = require("@tableau/tableau-ui");
var React = require("react");
var Declarative_1 = require("../utils/Declarative");
var TextLinkKind;
(function (TextLinkKind) {
    /** For inline links - To be used on light colored backgrounds */
    TextLinkKind["Standard"] = "standard";
    /** For stand-alone links - To be used on light colored backgrounds */
    TextLinkKind["LowEmphasis"] = "lowEmphasis";
    /** For inline links - To be used on dark colored backgrounds */
    TextLinkKind["StandardDark"] = "standard-dark";
    /** For stand-alone links - To be used on dark colored backgrounds */
    TextLinkKind["LowEmphasisDark"] = "lowEmphasis-dark";
})(TextLinkKind = exports.TextLinkKind || (exports.TextLinkKind = {}));
exports.TextLinkWidget = React.forwardRef(function (props, ref) {
    var testIdProp = props.testId, htmlProps = tslib_1.__rest(props, ["testId"]);
    return React.createElement(tableau_ui_1.TextLink, tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testIdProp, 'TextLink') }, htmlProps, { ref: ref }));
});
exports.TextLinkWidget.displayName = 'TextLinkWidget';
//# sourceMappingURL=TextLinkWidget.js.map